import domain from './domain';

// Reset user identity
export const resetUserIdentity = domain.createEvent('resetUserIdentity');

// Reset user email settings
export const resetUserEmailSettings = domain.createEvent('resetUserEmailSettings');
